//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import { ITikTokFormState } from '@universal-scheduling/models/SchedulerPostDetailsModels';

export const DEFAULT_TIKTOK_POST_DETAILS_STATE: ITikTokFormState = {
  postType: UniversalPostType.TikTokVideoAutomaticPost,
  postNow: false,
};

export const CAPTION_LENGTH_LIMIT = 2200;
export const MAX_TIKTOK_CAPTION_LENGTH = 2200;

export const TikTokPostDetailsFormFieldErrorText = {
  NoMediaOrText: 'Please add a caption to this post.',
  TextTooLong: `Please enter ${MAX_TIKTOK_CAPTION_LENGTH} characters or less.`,
} as const;
